import { render, staticRenderFns } from "./addQuotation.vue?vue&type=template&id=340d487a&scoped=true&"
import script from "./addQuotation.vue?vue&type=script&lang=js&"
export * from "./addQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340d487a",
  null
  
)

export default component.exports